import papel from './papel'
import permissaoAcesso from './permissao-acesso'

export default baseUrl => {
    baseUrl = `${baseUrl}/administracao`

    return {
        papel: papel(baseUrl),
        permissaoAcesso: permissaoAcesso(baseUrl),
    }
}